"use strict";
var api_date_parts_model_1 = require("./api-date-parts.model");
var DateInformation = (function () {
    function DateInformation(localDate, utcDate, olsonTimeZone, timeZoneAbbreviation) {
        this.localized = localDate ? localDate : new api_date_parts_model_1.DateParts();
        this.utc = utcDate ? utcDate : new api_date_parts_model_1.DateParts();
        this.localOlsonTimeZone = olsonTimeZone;
        this.localTimeZoneAbbreviation = timeZoneAbbreviation;
    }
    DateInformation.hasLocalizedDateString = function (info) {
        return Boolean(info && info.localized && info.localized.dateString);
    };
    return DateInformation;
}());
exports.DateInformation = DateInformation;
//# sourceMappingURL=D:/a/1/s/base/src/models/date-models/api-date-information.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/date-models/api-date-information.model.js